var React = require('react');

function Search (props) {
    return React.createElement("svg",props,React.createElement("g",{"id":"Symbols","stroke":"none","strokeWidth":"1","fill":"none","fillRule":"evenodd","strokeLinecap":"round","strokeLinejoin":"round"},React.createElement("g",{"id":"search","stroke":"#333333"},React.createElement("g",{"id":"Group","transform":"translate(5.000000, 5.000000)"},[React.createElement("path",{"d":"M5.5,5.5 L13.1485293,13.1485293","id":"Line","key":0}),React.createElement("circle",{"id":"Oval-2","fill":"#FFFFFF","cx":"6","cy":"6","r":"6","key":1})]))));
}

Search.defaultProps = {"width":"24px","height":"24px","viewBox":"0 0 24 24"};

module.exports = Search;

Search.default = Search;
